

























import Vue from 'vue';

import ModalControlsPanel from '@/components/Form/ModalControlsPanel.vue';

export default Vue.extend({
    name: 'ModalConfirm',
    components: {
        ModalControlsPanel,
    },
    props: {
        /** Значение, управляющее видимостью окна */
        modelValue: {
            type: Boolean,
            required: true,
            default: false,
        },
        /** id элемента формы модального окна */
        formId: {
            type: String,
            default: 'confirmId',
        },
        /** Заголовок */
        formTitle: {
            type: String,
            default: 'Подтвердить',
        },
        /** Текст в теле окна */
        formMessage: {
            type: String,
        },
        /** Текст кнопки подтверждения */
        comfirmText: {
            type: String,
            default: 'Ок',
        },
        /** Текст кнопки отмены */
        canselText: {
            type: String,
            default: 'Отмена',
        },
        /** Обслуживает ли форма асинхронный запрос */
        isAsync: {
            type: Boolean,
            default: false,
        },
        /** Текст ошибки при неудаче запроса */
        aleartMessage: {
            type: String,
            default: 'Bad request. Please try again.'
        },
        /** Наличие активного асинхронного запроса */
        activeRequest: {
            type: Boolean,
        },
        /** Наличие ошибки запроса */
        failRequest: {
            type: Boolean,
        },
    },
    model: {
        prop: 'modelValue',
        event: 'input',
    },
    computed: {
        isShowMessage(): boolean {
            return (
                this.formMessage !== undefined && this.formMessage.trim() !== ''
            );
        },
        isShowAleart(): boolean {
            return this.isAsync === true && this.failRequest === true;
        },
        isShowSpiner(): boolean {
            return this.isAsync === true && this.activeRequest === true;
        },
    },
    methods: {
        confirm(): void {
            this.$emit('input', false);
            this.$emit('confirm');
        },
        cansel(): void {
            this.$emit('input', false);
            this.$emit('cansel');
        },
        hidden() {
            this.$emit('input', false);
            this.$emit('hidden');
        },
    }
});
